// extracted by mini-css-extract-plugin
module.exports = {"faculty-details":"C50_2_FacultyDetail_faculty-details__hWzD9","intro":"C50_2_FacultyDetail_intro__gETbv","qualifications":"C50_2_FacultyDetail_qualifications__XTz0f"};